const Popup = ({ state, setState, children, containerClassName, header }) => {
  return (
    <>
      {state && (
        <>
          <div
            className="fixed top-0 left-0 w-full h-full bg-[#00000094] z-[99999]"
            onClick={() => setState(false)}
          ></div>
          <div
            className={`fixed min-w-[350px] md:w-1/2 z-[99999] p-8 -translate-x-1/2 -translate-y-1/2 
              bg-white dark:bg-gray-900 top-1/2 left-1/2 rounded-2xl 
              text-black dark:text-white ${containerClassName}`}
          >
            <div className="flex items-center justify-between mb-4">
              <h5 className="text-lg font-medium capitalize">{header}</h5>
              <span
                onClick={() => setState(false)}
                className="text-2xl transition-colors cursor-pointer hover:text-red-500"
              >
                ×
              </span>
            </div>
            {children}
          </div>
        </>
      )}
    </>
  );
};

export default Popup;
